import * as z from 'zod';

export const schema = z.object({
  email: z
    .string({
      required_error: 'fieldRequired',
      invalid_type_error: 'fieldRequired',
    })
    .email({
      message: 'invalidEmail',
    }),
  password: z
    .string({
      required_error: 'fieldRequired',
      invalid_type_error: 'fieldRequired',
  }),
  rememberMe: z.boolean().default(false).optional(),
});